import React from 'react';
interface ProgressBarProps {
  className?: string;
}
export function ProgressBar({
  className = ''
}: ProgressBarProps) {
  return <div className={`w-full max-w-[400px] mx-auto ${className}`} data-id="element-257">
      <div className="w-full h-[8px] bg-cream rounded-full overflow-hidden mb-2 border border-divider" data-id="element-258">
        <div className="h-full bg-pain w-[82%] rounded-full transition-all duration-1000" data-id="element-259"></div>
      </div>
      <p className="text-[11px] italic text-pain text-center font-bold" data-id="element-260">
        412 de 500 familias · Quedan 88 lugares
      </p>
    </div>;
}